export const MONTHS = [
    'Januar',
    'Februar',
    'März',
    'April',
    'Mai',
    'Juni',
    'Juli',
    'August',
    'September',
    'Oktober',
    'November',
    'Dezember',
];

export const QUARTERS = [
    { value: '1', label: '1. Quartal', monthRange: 'Januar bis März' },
    { value: '2', label: '2. Quartal', monthRange: 'April bis Juni' },
    { value: '3', label: '3. Quartal', monthRange: 'Juli bis September' },
    { value: '4', label: '4. Quartal', monthRange: 'Oktober bis Dezember' },
];
